import { Navigate } from "react-router-dom";

import { appRoutes } from "~/constants/appRoutes.ts";

// Each user lands on the dashboard, also a user with a manager permission: the client wants one
// personal start page for each team member, not a start page by permission.
export function LandingPage() {
	return <Navigate to={appRoutes.dashboard().path}
					 replace />;
}
